import React, { memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import {
  InputAdornment,
  InputBase,
} from "@mui/material";

export type SearchBarProps = {
  onChange?: (term: string) => void;
  placeholder?: string;
};

export const SearchBar = memo(function (props: SearchBarProps): JSX.Element {
  const [focus, setFocus] = React.useState(false);
  return (
    <InputBase
      sx={{
        display: "flex",
        flex: 1,
        paddingX: 2,
        paddingY: 0.5,
        borderRadius: 1,
        boxShadow: focus ? "0 0 0 2px rgba(25, 118, 210, 0.2)" : "0 0 0 1px #e0e0e0",
        transition: "box-shadow 0.3s ease",
      }}
      startAdornment={
        <InputAdornment position="start">
          <FontAwesomeIcon icon={faSearch} />
        </InputAdornment>
      }
      inputProps={{
        sx:{"&:focus": {
          boxShadow: "none",
          outline: "none",
        }},
        onFocus: () => setFocus(true),
        onBlur: () => setFocus(false),
      }}
      type="text"
      placeholder={props.placeholder || "Search..."}
      onChange={(e) => props.onChange?.(e.target?.value || "")}
      aria-label={props.placeholder || "Enter search terms"}
    />
  );
});

export default SearchBar;
